import { Box } from "@mui/joy"

interface PosterProps {
  posterUrl: string;
}

const Poster = ({ posterUrl }: PosterProps) => {
  return (
    <Box sx={{
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      backgroundImage: `url(${posterUrl})`,
      backgroundSize: "contain",
      backgroundRepeat: "no-repeat",
      backgroundPosition: "center",
      borderRadius: "12px"
    }}/>
  )
}

export default Poster;